var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.574,
    height: 15.602,
    viewBox: "0 0 15.574 15.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-call",
    d: "M10.976,3.74a3.426,3.426,0,0,1,2.706,2.706M10.976,1a6.166,6.166,0,0,1,5.447,5.44m-.685,5.467v2.055a1.37,1.37,0,0,1-1.494,1.37,13.558,13.558,0,0,1-5.912-2.1A13.36,13.36,0,0,1,4.221,9.118a13.558,13.558,0,0,1-2.1-5.94A1.37,1.37,0,0,1,3.481,1.685H5.536a1.37,1.37,0,0,1,1.37,1.178,8.8,8.8,0,0,0,.48,1.925,1.37,1.37,0,0,1-.308,1.446l-.87.87a10.962,10.962,0,0,0,4.111,4.111l.87-.87a1.37,1.37,0,0,1,1.446-.308,8.8,8.8,0,0,0,1.925.48,1.37,1.37,0,0,1,1.178,1.391Z",
    transform: "translate(-1.511 -0.337)",
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.d49f39b747a727449c034ab484d8edc2.svg";
export { ForwardRef as ReactComponent };